// extracted by mini-css-extract-plugin
export default {"container":"JN-z","topReviewHeading":"KN-z","criticalReview":"LN-z","favorableReview":"MN-z","vsSeparator":"NN-z"};